export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL ?? "").replace(/\/+$/, "");

export class ApiError extends Error {
    constructor(message, status, payload) {
        super(message);
        this.status = status;
        this.payload = payload;
    }
}

function authHeaders(extra = {}) {
    let token = null;
    try { token = sessionStorage.getItem("cvi_token"); } catch { token = null; }
    return { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...extra };
}

export async function apiRequest(path, { method = "GET", body, signal } = {}) {
    const response = await fetch(`${API_BASE_URL}${path}`, {
        method,
        signal,
        headers: authHeaders(body !== undefined ? { "Content-Type": "application/json" } : {}),
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new ApiError(payload.message || (response.status >= 500 ? "Something went wrong on our side. Please try again." : "The request could not be completed. Please try again."), response.status, payload);
    return payload;
}

// Small shared cache so several dashboard components asking for the same resource
// during one render pass trigger a single request.
const cache = new Map();
export function cachedRequest(path, { ttlMs = 30000, key = path } = {}) {
    const now = Date.now();
    const hit = cache.get(key);
    if (hit && now - hit.at < ttlMs) return hit.promise;
    const promise = apiRequest(path).catch(error => { cache.delete(key); throw error; });
    cache.set(key, { at: now, promise });
    return promise;
}
export function invalidateCached(prefix) {
    for (const key of [...cache.keys()]) if (key.startsWith(prefix)) cache.delete(key);
}
